export default "__VITE_ASSET__DkxhSYPw__"